import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'store/store';
import {
  clearCheckoutSession,
  getCheckoutSession,
  selectCheckoutSession,
  selectCheckoutSessionRemainingMs,
  setCheckoutSession,
  startCheckoutSession,
  updateCheckoutSessionData,
  updateCheckoutSessionStep,
  TCheckoutSession,
  TCheckoutSessionData,
  TCheckoutSessionStep,
} from 'store/checkoutSession';

export const useCheckoutSession = () => {
  const dispatch = useAppDispatch();
  const session = useAppSelector(selectCheckoutSession);
  const remainingMs = useAppSelector(selectCheckoutSessionRemainingMs);

  const startSession = useCallback(
    (checkoutData: TCheckoutSessionData) => {
      dispatch(startCheckoutSession({ checkoutData }));
    },
    [dispatch]
  );

  const replaceSession = useCallback(
    (nextSession: TCheckoutSession) => {
      dispatch(setCheckoutSession(nextSession));
    },
    [dispatch]
  );

  const updateData = useCallback(
    (nextData: Partial<TCheckoutSessionData>) => {
      dispatch(updateCheckoutSessionData(nextData));
    },
    [dispatch]
  );

  const updateStep = useCallback(
    (step: TCheckoutSessionStep) => {
      dispatch(updateCheckoutSessionStep(step));
    },
    [dispatch]
  );

  const clearSession = useCallback(() => {
    dispatch(clearCheckoutSession());
  }, [dispatch]);

  const refreshFromStorage = useCallback(() => {
    dispatch(getCheckoutSession());
  }, [dispatch]);

  return {
    session,
    remainingMs,
    startSession,
    replaceSession,
    updateData,
    updateStep,
    clearSession,
    refreshFromStorage,
  };
};
